export const env = {

    oauth_client: {
        id: '2',
        secret: 'qxmBi9TM8DhaALlCwGVmaNBw9dnd2fslEa2i4jRa'
    },

    scarecrow_bless_key: 'FlquI0wKLuet7JfzO3O6GkUeNWxiRmmYNSJWJ6hUqBEnLkdbdrXjRsEgF2EYeqxs',
    translations_host: 'https://checkout.betalabs.net/assets/translations/',

    recaptcha_site_key: '6Ld50kIcAAAAAE3FMMUTu4mgCjquRHZqIyNd_ivq',

    aws_access_key: 'AKIAR2EM6WX3PJHIYDJ2',
    aws_secret_key: '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',
    aws_region: 'us-east-1',
    aws_log_group_name: '/checkout/production'
};



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/app.env.ts